var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-font",style:({
    width: _vm.width * _vm.scale + 'px',
    height: _vm.height * _vm.scale + 'px',
    backgroundPosition: '0px -' + (_vm.number - 1) * (_vm.height * _vm.scale) + 'px'
  })})}
var staticRenderFns = []

export { render, staticRenderFns }